module.exports = __webpack_public_path__ + "static/media/logo.b98cf0d2.png";